__turbopack_context__.v({
  "react-player": "QQFk0W_react-player",
  "react-player-hero": "QQFk0W_react-player-hero",
});
